import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../../Component/NavBar/Navbar";
import "./RecommendPageStyles.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  notificationAction,
  getInlineImage,
  markUnmarkFavourite,
  getAnswerRatingsInNotificationAction,
  rateRecommandedAnswer,
  URLDerectionData,
  getExpertsProfilePics,
  askClarificationExpert,
  getQuestionDraftData,
  URLOpenDerectionData,
  FetchForceReroute
} from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { editQuestionText, recommendQuestionData, getAttachmentShowURL } from "../../API/api";
import { handleError, handlePlayPause } from "../../utils";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import { CarouselItem, OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { replaceContentEditableText } from "../../utils";
import AttachmentBox from "../../Component/AttachmentBox/AttachmentBox";
import CarouselImage from "../../Component/Carousel/Carousel";
import { Carousel } from "react-responsive-carousel";
import SkeletonLoader from "../../Component/SkeletonLoader/SkeletonLoader";
import FeedbackWindow from "../../Component/FeedbackWindow/FeedbackWindow";
import { toast } from "react-toastify";
import styles from "../../Component/Rating/RatingStyles.module.css";
import { handlePauseAllVideo } from "../../utils";
import MiniDrawer from "../../Component/newNavBar/newNavBar";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { CURRENT_ROLE } from "../../API/url";
import { styled, } from '@mui/material/styles';
import { Button, modalClasses } from "@mui/material";
import FontDownloadIcon from '@mui/icons-material/FontDownload';

export default function RecommendPage() {
  const dispatch = useDispatch();
  const {
    notificationsDataRecommend,
    notificationDataLoading,
    advanceFilterModalToggle,
    getSelectedAnswer,
    getSelectedQuestion,
    attachmentData,
    isBackClickedOnRecommend,
    recommendData,
    preservePreviousRecommendData,
    getkeyTagPayload,
    getExpertRequestUuid,
    questionDataForEditor,
    updateSubmissionTypeForEditor,
    updateAnswerTextForEditor,
    updatePageNumberExpertOpenTab,
    getDomainOfQuestion,
    getSelectedQuestionDataExpert,
    getForceRerouteUsersStatus,
    updateAttachmentForEditor,
    getSeekerAttachmentsForReccommend,
    getSeekerAttachment
  } = bindActionCreators(Actions, dispatch);
  const navigate = useNavigate();
  const currentRoute = useLocation();
  const [isShowReply, setIsShowReply] = useState(false);
  const recommedState = useSelector((state) => state.recommend);
  const data = useSelector((state) => state.recommend.data);
  const origData = useSelector((state) => state.recommend.data);
  const [ratings, setRatings] = useState(null);
  const [clarify, setClarify] = useState(false);
  const [val, setValue] = useState("");
  const [additional, setAdditional] = useState("");
  const questiondata = useSelector((state) => state.recommend);
  const questionText = useSelector((state) => state.recommend.data.question);
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const [allInlineImages, setAllInlineImages] = useState(null);
  const [ratingIds, setRatingIds] = useState([]);
  const [docIds, setDocIds] = useState([]);
  const [recommendations, setRecommendation] = useState([]);
  const [clarificationTextExpert, setClarificationTextExpert] = useState("");
  const [isShowAnswerButton, setIsShowAnswerButton] = useState(false);
  
  const onChangeReplyBox = () => {
    setIsShowReply(!isShowReply);
  };

  const questionNotInYourQueue = (message) => {
    return(
      <span style={{fontSize:'12px'}}>{message}</span>
    )
  }

  const selectTag = (tag) => {
    getkeyTagPayload(null);
    getkeyTagPayload(tag);
    if (!currentRoute.pathname.includes(`${Home_PAGE_URL}tagdata`)) {
      navigate(`${Home_PAGE_URL}tagdata`);
    }
  };

  const callApi = () => {
    if (!recommedState.isBack) {
      let preservedData = recommedState.prevData;
      preservedData.push(recommedState.recommendPayload);
      preservePreviousRecommendData(preservedData);
    }
    if (
      recommedState.recommendPayload.data &&
      recommedState.recommendPayload.data.queUuid !== undefined
    ) {
      setRecommendation([]);
      notificationDataLoading(true);
      let userUuid = [];
      const payload = {
        notificationId: [recommedState.recommendPayload.data.msgUuid],
        questionUuid: [recommedState.recommendPayload.data.queUuid],
      };
      notificationAction(payload).then((res) => {
        if (res===undefined) return;
        if (res !== undefined && res.data.success) {
          // console.log(res.data.data,'check response data')
          if(res.data.data.seekerAttachments && res.data.data.seekerAttachments !== null)
          {
            getSeekerAttachmentsForReccommend(res.data.data.seekerAttachments)
          }
          let answerUuids = res.data.data.answers.map((k, i) => {
            return k.answerUuid;
          });
          setRatingIds(answerUuids);
          notificationDataLoading(false);
          setClarify(false);
          notificationsDataRecommend(res.data.data);
          getSelectedAnswer(res.data.data.answers);
          getAnswerRatingsInNotificationAction(answerUuids.toString(), "").then(
            (res) => {
              if (res !== undefined && res.data.success === true) {
                setRatings(res.data.data);
              }
            }
          );
          setValue(res.data.data.question);
          setAdditional(res.data.data.additionalContext);
          res.data.data.answers.filter((ans) => {
            userUuid.push(ans.expertUuid);
            if (ans.attachments.length > 0) {
              ans.imageAttachments = ans.attachments.filter((attachment) => {
                if (
                  attachment.name.includes(".png") ||
                  attachment.name.includes(".jpg") ||
                  attachment.name.includes(".jpeg")||
                  attachment.name.includes(".JPEG") ||
                  attachment.name.includes(".JPG") ||
                  attachment.name.includes(".PNG")
                ) {

                  return attachment;
                }
              });
            } else {
              ans.imageAttachments = [];
            }
            if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
              getInlineImage(ans.inlineImages)
                .then((res2) => {
                  if (res2 !== undefined && res2.data.success) {
                    let inlineDatas = res2.data.data;
                    setAllInlineImages({ ...allInlineImages, inlineDatas });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });
          notificationsDataRecommend(res.data.data);
          getExpertsProfilePics(userUuid, undefined);
        } else {
          if (res === undefined) {
            navigate(`${Home_PAGE_URL}`);
          }
        }
      });
    } else if(recommedState.recommendPayload.isUrlRedirection !== undefined){
      notificationDataLoading(true);
      let userUuid = [];
      if(recommedState.recommendPayload.type==='open'){
        URLOpenDerectionData(recommedState.recommendPayload.quesUuid).then((res) => {
          if (res !== undefined && res?.data?.success) {
            if(recommedState.recommendPayload.type==='open'){
              setIsShowAnswerButton(true);
            }
            if(res.data.data.length === 0){
              // toast.warning("Question is not in your queue anymore!", {
              //   position: toast.POSITION.TOP_RIGHT,
              // });
                 toast.warning(questionNotInYourQueue("Question is not in your queue anymore!"), {
                position: toast.POSITION.TOP_RIGHT,
              });
              updatePageNumberExpertOpenTab(0)
              navigate('/expertHome/open');
              return 
            }
            res.data.data[0].question = res.data.data[0].questionText;
            notificationDataLoading(false);
            setClarify(false);
            notificationsDataRecommend(res.data.data[0]);
            getSelectedAnswer([]);
            setValue(res.data.data[0].questionText);
            setAdditional(res.data.data[0].additionalContext);
            // res.data.data[0].answers.filter((ans) => {
            //   userUuid.push(ans.expertUuid);
            //   if (ans.attachments.length > 0) {
            //     ans.imageAttachments = ans.attachments.filter((attachment) => {
            //       if (
            //         attachment.name.includes(".png") ||
            //         attachment.name.includes(".jpg") ||
            //         attachment.name.includes(".jpeg")
            //       ) {
  
            //         return attachment;
            //       }
            //     });
            //   } else {
            //     ans.imageAttachments = [];
            //   }
            //   if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
            //     getInlineImage(ans.inlineImages)
            //       .then((res2) => {
            //         if (res2 !== undefined && res2.data.success) {
            //           let inlineDatas = res2.data.data;
            //           setAllInlineImages({ ...allInlineImages, inlineDatas });
            //         }
            //       })
            //       .catch((err) => {
            //         console.log(err);
            //       });
            //   }
            // });
            notificationsDataRecommend(res.data.data[0]);
            getExpertsProfilePics(userUuid, undefined);
          } else {
            if (res.data === undefined) {
              navigate(`${Home_PAGE_URL}`);
            }
          }
        });
      }else{
        URLDerectionData(recommedState.recommendPayload.quesUuid).then((res) => {
          if (res !== undefined && res?.data?.success) {
            if(recommedState.recommendPayload.type==='open'){
              setIsShowAnswerButton(true);
            }
            let answerUuids = res.data.data.answers.map((k, i) => {
              return k.answerUuid;
            });
            setRatingIds(answerUuids);
            notificationDataLoading(false);
            setClarify(false);
            notificationsDataRecommend(res.data.data);
            getSelectedAnswer(res.data.data.answers);
            getAnswerRatingsInNotificationAction(answerUuids.toString(), "").then(
              (res) => {
                if (res !== undefined && res.data.success === true) {
                  setRatings(res.data.data);
                }
              }
            );
            setValue(res.data.data.question);
            setAdditional(res.data.data.additionalContext);
            if(res.data.data.seekerAttachments && res.data.data.seekerAttachments !== null)
            {
              getSeekerAttachmentsForReccommend(res.data.data.seekerAttachments)
            }
            res.data.data.answers.filter((ans) => {
              userUuid.push(ans.expertUuid);
              if (ans.attachments.length > 0) {
                ans.imageAttachments = ans.attachments.filter((attachment) => {
                  if (
                    attachment.name.includes(".png") ||
                    attachment.name.includes(".jpg") ||
                    attachment.name.includes(".jpeg")||
                    attachment.name.includes(".JPEG") ||
                    attachment.name.includes(".JPG") ||
                    attachment.name.includes(".PNG")
                  ) {
  
                    return attachment;
                  }
                });
              } else {
                ans.imageAttachments = [];
              }
              if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
                getInlineImage(ans.inlineImages)
                  .then((res2) => {
                    if (res2 !== undefined && res2.data.success) {
                      let inlineDatas = res2.data.data;
                      setAllInlineImages({ ...allInlineImages, inlineDatas });
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            });
            notificationsDataRecommend(res.data.data);
            getExpertsProfilePics(userUuid, undefined);
          } else {
            if (res.data === undefined) {
              navigate(`${Home_PAGE_URL}`);
            }
          }
        });
      }
    }else {
      const payload = {
        id: recommedState.recommendPayload.data.id,
        text: recommedState.recommendPayload.data.text,
      };
      let userUuid = [];
      notificationDataLoading(true);
      recommendQuestionData(payload).then((res) => {
        if (res===undefined) return;
        if(res.data.data[0].details === null){
          toast.warning(successfulQuestionUpdated("Question has been moved out of your queue. --This QA has been updated. Please refresh to see the latest!"), {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/seekerHome/");
          return;
        }
        if (res !== undefined && res.data.success) {
          setRecommendation(res.data.data[0].recommendations);
          let answerUuids = res.data.data[0].details.answers.map((k, i) => {
            return k.originalAnswerUuid;
          });
          let docUuids = res.data.data[0].details.answers.map((k, i) => {
            return k.docId;
          });
          setDocIds(docUuids);
          setRatingIds(answerUuids);
          notificationDataLoading(false);
          setClarify(false);
          notificationsDataRecommend(res.data.data[0].details);
          getSelectedAnswer(res.data.data[0].details.answers);
          getAnswerRatingsInNotificationAction(
            answerUuids.toString(),
            docUuids.toString()
          ).then((res1) => {
            if (res1 !== undefined && res1.data.success === true) {
              setRatings(res1.data.data);
            }
          });
          setValue(res.data.data[0].details.question);
          setAdditional(res.data.data[0].details.additionalContext);
          res.data.data[0].details.answers.filter((ans) => {
            if(res.data.data[0].details.reusableThreadQA){
              ans.threadAttachments.unshift([]);
              ans.threadAttachments.unshift([]);
            }
            userUuid.push(ans.expertUuid);
            if (ans.answer.includes("vizsep")) {
              ans.threadAttachmentsURL = [];
              ans.threadAttachments.filter((att1) => {
                if (att1.length === 0) {
                  ans.threadAttachmentsURL.push([]);
                } else {
                  let asdffgh = [];
                  att1.filter((att2) => {
                    if (
                      att2.name.includes(".jpeg") ||
                      att2.name.includes(".jpg") ||
                      att2.name.includes(".png")||
                      att2.name.includes(".JPEG") ||
                      att2.name.includes(".JPG") ||
                      att2.name.includes(".PNG")
                    ) {
                      let payload = { name: att2.name };
                      getAttachmentShowURL(payload)
                        .then((res1) => {
                          if(res1 === undefined){
                            return;
                          }
                          asdffgh.push(res1.data.data);
                        })
                        .catch((err) => {
                          handleError(err);
                        });
                    }
                  });
                  ans.threadAttachmentsURL.push(asdffgh);
                }
              });
            }
            if (ans.attachments.length > 0) {
              ans.imageAttachments = ans.imageAttachments =
                ans.attachments.filter((attachment) => {
                  if (
                    attachment.name.includes(".png") ||
                    attachment.name.includes(".jpg") ||
                    attachment.name.includes(".jpeg")||
                    attachment.name.includes(".JPEG") ||
                    attachment.name.includes(".JPG") ||
                    attachment.name.includes(".PNG")
                  ) {

                    return attachment;
                  }
                });
            } else {
              ans.imageAttachments = [];
            }
            if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
              getInlineImage(ans.inlineImages)
                .then((res2) => {
                  if (res2 !== undefined && res2.data.success) {
                    let inlineDatas = res2.data.data;
                    setAllInlineImages({ ...allInlineImages, inlineDatas });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });
          notificationsDataRecommend(res.data.data[0].details);
          getExpertsProfilePics(userUuid, undefined);
        }
      });
    }
  };
  const onClickMarkFavorite = () => {
    markUnmarkFavourite(recommedState.data.questionUuid)
      .then((res) => {
        recommedState.data.favourite = !recommedState.data.favourite;
        notificationsDataRecommend(data);
      })
      .catch((err) => handleError(err));
  };
  useEffect(() => {
    if (recommedState.recommendPayload === null) {
      navigate(`${Home_PAGE_URL}`);
      return;
    }
    callApi();
  }, [recommedState.recommendPayload]);

  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };

  const renderTooltipAnsweredBadge = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Most Answered Badge
    </Tooltip>
  );

  const renderTooltipQualityBadge = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Quality Answered Badge
    </Tooltip>
  );

  const renderTooltipAmplifiedBadge = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Amplified Answer Badge
    </Tooltip>
  );

  const renderTooltipViewCount = (props) => {
    <Tooltip id="viewCountTooltip" {...props}>
      No of times this question was viewed
    </Tooltip>;
  };

  const [isExpand, setIsExpand] = useState(false);
  const onChangeExpand = (flag) => {
    setIsExpand(flag);
  };

  const CarouselData = ({ attachments }) => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Carousel>
            <div>
              <img src={attachments.src} />
            </div>
          </Carousel>
        </div>
      </>
    );
  };

  const onclickUpdateQ = () => {
    let obj = {
      questionUuid: data.questionUuid,
      questionText: val,
      domain: data.domain,
      postedDate: data.postedTimestamp,
      additionalContext: additional,
    };
    editQuestionText(obj).then((res) => {
      if (res !== undefined) {
        data.question = val;
        data.clarificationStatus = false;
        data.additionalContext = additional;
        setClarify(false);
        if (res.data.data !== undefined || res.data.success) {
          toast.success(successfulQuestionUpdated(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    });
  };

  const conditionalStyles = {
    div: {
      display: clarify ? null : "flex",
      justifyContent: clarify ? null : "space-between",
      alignItems:'baseline'
    },
  };

  const sendToHomePage = () => {
    if(recommedState.recommendPayload.isUrlRedirection === undefined || recommedState.recommendPayload.type ==='editor'){
      let preserved = recommedState.prevData;
    preserved.pop();
    preservePreviousRecommendData(preserved);
    if (preserved.length > 0) {
      recommendData(preserved[preserved.length - 1]);
    }
    isBackClickedOnRecommend(true);
    setTimeout(() => {
      isBackClickedOnRecommend(false);
    }, 3000);
    navigate(-1);
    }else{
      navigate(`${Home_PAGE_URL}`);
    }
  };

  const onChangeTextAreaContent = (e) => {
    e.preventDefault();
    setValue(e.target.value);
  };
  const onChangeAddiText = (e) => {
    setAdditional(e.target.value);
  };

  const onChangeCancel = () => {
    setClarify(false);
    setValue(questionText);
    setAdditional(data.additionalContext);
  };

  const onChangeClarificationText = (e) => {
    setClarificationTextExpert(e.target.value);
  }

  const onClickCancel = () => {
    setClarify(!clarify)
  }

 
  const onClickSubmitClarificationExpertRole = () => {
    const payload = {
      clarificationQuestion: clarificationTextExpert,
      questionUuidStr: data.questionUuid
    }
    askClarificationExpert(payload).then((res) => {    
      if (res===undefined) return;
      if (res.data.success || res.data.data !== '') {
        setClarify(!clarify);
        setClarificationTextExpert('');
        // data.clarificationStatus = !data.clarificationStatus;
        data.clarificationStatus = true;
        toast.success(successfulClarificationQuestion(), {
          position: toast.POSITION.TOP_RIGHT,
      });
      }
    })
  }

  const renderClarifyCard = () => {
    return (
      <div className="row">
        <div className="col-sm-12">
          <div
            className="clarificationBox"
            style={{
              backgroundColor: `${!data.clarificationStatus && "#fff"}`,
            }}
          >
            <div
              className="clarificationAlignment"
              style={{ float: `${!data.clarificationStatus ? "right" : null}` }}
            >
              {data.clarificationStatus && (
                <div>
                  <span className="clarificationText">
                    Clarification request from expert{" "}
                  </span>
                  <span className="clarificationSubText">
                    (Clarify question to allow an expert to provide the best
                    answer)
                  </span>
                </div>
              )}
              {data.clarificationStatus ? (
                <div style={{ display: "flex" }}>
                  <span
                    className="clarifyPopUp"
                    onClick={() => setClarify(false)}
                  >
                    Expert requested for clarification
                  </span>
                  <i
                    className="fa fa-pencil-square-o"
                    style={{ color: "#fd7400" }}
                    onClick={() => setClarify(false)}
                  ></i>
                  <i
                    className={`fa fa-heart ${
                      data.favourite ? "animate-like" : "dropdownFavorite"
                    }`}
                    style={{ margin: "0px 15px" }}
                    onClick={() => onClickMarkFavorite()}
                  ></i>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <i
                    className="fa fa-pencil-square-o"
                    onClick={() => setClarify(false)}
                  ></i>
                  <i
                    className={`fa fa-heart ${
                      data.favourite ? "animate-like" : "dropdownFavorite"
                    }`}
                    style={{ marginLeft: "3px" }}
                    onClick={() => onClickMarkFavorite()}
                  ></i>
                </div>
              )}
            </div>
            <div>
              <ul>
                {data.clarificationStatus &&
                  data.clarifications.map((clar) => {
                    return (
                      <li style={{ listStyleType: "square" }}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: replaceContentEditableText(clar.context),
                          }}
                        ></div>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="textAreaDiv">
            <textarea
              style={{ width: "100%" }}
              value={val}
              className="questionTextTextArea"
              onChange={(e) => onChangeTextAreaContent(e)}
            ></textarea>
          </div>
          {
            data.seekerAttachments && data.seekerAttachments !== null && data.seekerAttachments.length > 0 && (
              <div style={{ marginBottom: '5px' }}>
                {data.seekerAttachments.map((obj, ind) => {
                  return <AttachmentBox key={ind} attachment={obj} />
                })}
              </div>
            )
          }
          <div>
            <textarea
              placeholder="Additional Context"
              value={additional}
              style={{ width: "100%", outline: "none", fontSize: "14px", borderColor:'lightgrey', borderRadius:'3px' }}
              onChange={(e) => onChangeAddiText(e)}
            ></textarea>
          </div>
          <div style={{ display: "flex" }}>
            <div className="domainDisplay">
              <span className="domainText">Domain&nbsp; </span>
              <span className="domainName">{data.domain}</span>
            </div>
            <div className="timestampDisplay" style={{ paddingLeft: "12px" }}>
              <span className="domainText">Asked&nbsp; </span>
              <span className="dateText">
                {moment(data.postedTimestamp).format("MMM DD, YYYY")}
              </span>
            </div>
          </div>
          <div className="tagDisplay" style={{ paddingLeft: 0 }}>
            {data.tags && data.tags.length > 0 ? (
              <span className="domainText">Tags&nbsp; </span>
            ) : null}
            {data.tags && data.tags.length > 0
              ? data.tags.map((ta, index) => {
                  return (
                    <span
                      key={index}
                      className={
                        ta.clickable ? "tagNames" : "tagNamesNonClickable"
                      }
                      onClick={() => selectTag(ta)}
                    >
                      {ta.term}
                    </span>
                  );
                })
              : null}
          </div>
          <div className="col-sm-12 col-lg-12 col-md-12 text-end">
            <button
              className="qaRecordButtons btn"
              onClick={() => onChangeCancel()}
            >
              Cancel
            </button>
            <button
              className="btn qaRecordButtons2"
              disabled={
                data.clarificationStatus
                  ? val && val.length > 0 && additional && additional.length > 0
                    ? false
                    : true
                  : val && val.length > 0
                  ? false
                  : true
              }
              id="updateButton"
              onClick={() => onclickUpdateQ()}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderClatifyCardForExpertRole = () => {
    return (
      <>
        <div className="clarifyBoxExpert">
          <span style={{ fontSize: "14px" }}></span>
          <textarea placeholder="Ask your clarification to question here" value={clarificationTextExpert} onChange={(e) => onChangeClarificationText(e)} rows={5} style={{ width: "100%", fontSize: "14px", outline: "none", border: "1px solid lightgray" }}></textarea>
          <button className="btn-warning submitButtonExpert" disabled={clarificationTextExpert === '' ? true : false} onClick={() => onClickSubmitClarificationExpertRole()} >Submit</button>
          <button className="btn-warning submitButtonExpert" onClick={() => onClickCancel()} >Cancel</button>
        </div>
      </>
    )
  }

  const successfulQuestionUpdated = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };

  const successfulClarificationQuestion = () => {
    return (
        <>
            <p style={{ fontSize: "13px", fontWeight: "bold" }}>Great!</p>
            <span style={{ fontSize: "11px" }}>
                Your request for clarification has been forwarded to the seeker
            </span>
        </>
    );
};

const AnswerNowButton = styled(Button)({
  backgroundColor: '#bedb39',
  borderColor: '#bedb39',
  border: '1px solid #bedb39',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
      borderColor: '#bedb39',
      border: '1px solid #bedb39',
      backgroundColor: '#fff',
      color: '#bedb39',
  }
})

const DeclineButton = styled(Button)({
  backgroundColor: 'var(--dark_color_shade)',
  borderColor: 'var(--dark_color_shade)',
  border: '1px solid var(--dark_color_shade)',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
      borderColor: 'var(--dark_color_shade)',
      border: '1px solid var(--dark_color_shade)',
      backgroundColor: '#fff',
      color: 'var(--dark_color_shade)',
  }
})

const onClickModalDecline = () => {
  advanceFilterModalToggle({ bool: true, value: "expertDecline" });
  getExpertRequestUuid(data.expertRequestUuid);
}

  const isAnsweredByMe = (arr) => {
    let id = ""
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        id = obj.answerUuid;
      }
    })
    return id;
  }

  const onClickAnswerNow = (data) => {
    questionDataForEditor(data);
    updateAttachmentForEditor(data.attachments)
    updateSubmissionTypeForEditor('answer');
    if(data.seekerAttachments && data.seekerAttachments !== null)
    {
      getSeekerAttachment(data.seekerAttachments)
    }
    getQuestionDraftData(data.questionUuid).then(res => {
      if (res===undefined) return;
      if (res.data.data.length > 0) {
        updateAnswerTextForEditor(res.data.data[0].answer);
        navigate('/expertHome/editor');
      } else {
        updateAnswerTextForEditor('');
        navigate('/expertHome/editor');
      }
    })
  }


  const AnswerText = ({ data }) => {
    const extractProfilePicFromStore = () => {
      let imgData = searchState.usersProfilePicData.find(
        (obj) => obj.uuid === data.expertUuid
      );

      if (imgData !== undefined) {
        let userPic = `data:image/JPEG;base64,${imgData.img}`;
        return userPic;
      } else {
        return "";
      }
    };

    const replaceIdsWithImages = (text) => {
      if (allInlineImages !== null) {
        for (let i = 0; i < data.inlineImages.length; ++i) {
          if (data.inlineImages[i].includes(".png")) {
            let imgTag = `<img width=50% src=${
              allInlineImages.inlineDatas[data.inlineImages[i]]
            }></img>`;
            let replacedContent = `[content|${
              data.inlineImages[i].split(".")[0]
            }|]`;
            text = text.replace(replacedContent, imgTag);
          } else {
            let imgTag = `<img width=50% src=${
              allInlineImages.inlineDatas[data.inlineImages[i]]
            }></img>`;
            let replacedContent = data.inlineImages[i];
            text = text.replace(replacedContent, imgTag);
          }
        }
      }
      return text;
    };
    const onClickSendModalData = () => {
      advanceFilterModalToggle({ bool: true, value: "followUpModal" });
      getSelectedAnswer(data);
      getSelectedQuestion(questiondata.data);
      if(questiondata.data.seekerAttachments && questiondata.data.seekerAttachments !== null)
      {
        getSeekerAttachmentsForReccommend(questiondata.data.seekerAttachments)
      }
    };

    const saveAttachmentData = (data) => {
      attachmentData(data);
    };

    return (
      <div
        className="row"
        style={{
          border: "1px solid #ececec",
          borderRadius: "5px",
          marginBottom: "5px",
          marginTop: "5px",
        }}
      >
        <div
          className="col-sm-12"
          style={{ display: "flex", paddingTop: "7px" }}
        >
          <div className="userpic">
            {data.expertLastName !== "Bot" && (
              <img
                style={{ width: "40px", height: "40px", borderRadius: "20px" }}
                src={
                  extractProfilePicFromStore() ||
                  require("../../Images/cliente.png")
                }
                className="rounded-circle"
              />
            )}
            {data.expertLastName === "Bot" && (
              <img
                style={{ width: "40px", height: "40px", borderRadius: "20px" }}
                src={require("../../Images/bot-icon.png")}
                className="rounded-circle"
              />
            )}
          </div>
          <div className="username">
            {data.expertFirstName}&nbsp;
            {data.expertLastName === "Bot" ? "" : data.expertLastName}
            {
              data.expertScore && data.badges && data.badges.length === 0 && data.expertLastName !== "Bot" && (
                <span style={{ marginTop: "-3px" }}>
                  <i
                    className="fa fa-star"
                    style={{
                      color: "#b4c6cc",
                      fontSize: "14px",
                      paddingRight: "3px",
                    }}
                  ></i>
                  <span className="userscorenumber">
                    {Math.round(data.expertScore)}
                  </span>
                  <span style={{ color: "#949494" }} className="userscore">
                    /10
                  </span>
                </span>
              )
            }
            <span>
              {data.expertLastName !== "Bot" &&
                data.badges &&
                data.badges.length > 0 && (
                  <span
                    className="ms-2"
                    style={{ fontSize: "13px", cursor: "pointer" }}
                  >
                    {data.badges.map((badge) => {
                      if (badge.name === "answered") {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAnsweredBadge}
                          >
                            <span>🏅&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "quality") {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipQualityBadge}
                          >
                            <span>🌟&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "amplified") {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAmplifiedBadge}
                          >
                            <span>🏆&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                    })}
                  </span>
                )}
            </span>
            <div>
              {data.answeredTimestamp < data.answerUpdatedTimestamp && (
                <>
                  <span className="answeredTimestamp">Last Updated:</span>
                  <span className="answeredTimestamp">
                    {momentit(data.answerUpdatedTimestamp)}
                  </span>
                </>
              )}
              {data.answeredTimestamp === data.answerUpdatedTimestamp && (
                <>
                  <span className="answeredTimestamp">Answered</span>
                  <span className="answeredTimestamp">
                    {momentit(data.answeredTimestamp)}
                  </span>
                </>
              )}
            </div>
          </div>
          {data.expertScore && data.badges && data.badges.length > 0 && (
            <span style={{ marginTop: "-3px" }}>
              <i
                className="fa fa-star"
                style={{
                  color: "#b4c6cc",
                  fontSize: "14px",
                  paddingRight: "3px",
                }}
              ></i>
              <span className="userscorenumber">
                {Math.round(data.expertScore)}
              </span>
              <span style={{ color: "#949494" }} className="userscore">
                /10
              </span>
            </span>
          )}
          {data.internal === true && (
            <div style={{ marginLeft: "auto" }}>
              <span
                className=""
                style={{
                  color: "gray",
                  fontWeight: "300",
                  fontSize: "13px",
                }}
              >
                <i className="fa fa-user-times"></i>&nbsp;Internal Only
              </span>
            </div>
          )}
        </div>
        {!data.answer.includes("vizsep") && (
          <div className="col-sm-12">
            {data.answer.length >= 550 ? (
              <div
                className={`answerText ${isExpand ? "" : "hideAnswerText"}`}
                dangerouslySetInnerHTML={{
                  __html: replaceIdsWithImages(
                    replaceContentEditableText(data.answer)
                  ),
                }}
              >
                {/* {recommedState.inlineImageData.toString()} */}
              </div>
            ) : (
              <div
                className={`answerText`}
                dangerouslySetInnerHTML={{
                  __html: replaceIdsWithImages(
                    replaceContentEditableText(data.answer)
                  ),
                }}
              ></div>
            )}
          </div>
        )}
        {data.answer.includes("vizsep") && (
          <div
            className="row mt-4 me-2 mb-2"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <div className="firstThreadLayout" style={{ width: "95%" }}>
              <div
                className="innerThreadDiv"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h4 className="firstReply" style={{ width: "80%" }}>
                  {data.answer.split("vizsep") &&
                    data.answer.split("vizsep")[0]}
                </h4>
                {!isShowReply ? (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Show {data.answer.split("vizsep").length - 1} Replies{" "}
                    <i
                      className="fa fa-arrow-down"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                ) : (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Hide Replies{" "}
                    <i
                      className="fa fa-arrow-up"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                )}
              </div>
              {data.threadAttachmentsURL[0].length > 0 && (
                <div style={{ textAlign: "center" }}>
                  <CarouselImage attachments={data.threadAttachmentsURL[0]} />
                </div>
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {data.threadAttachments &&
                  data.threadAttachments[0].map((attachment) => {
                    return (
                      <div className="mt-3 mb-3 ms-3">
                        <AttachmentBox attachment={attachment} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
        {isShowReply &&
          data.answer.includes("vizsep") &&
          data.answer.split("vizsep").map((thread, index) => {
            if (index !== 0) {
              return (
                <div
                  className="row me-2 mb-2"
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <div className="firstThreadLayout" style={{ width: "90%" }}>
                    <div className="innerThreadDiv">
                      <h4 className="firstReply">{thread}</h4>
                    </div>
                    {data.threadAttachmentsURL[index].length > 0 && (
                        <div style={{ textAlign: "center" }}>
                          <CarouselImage
                            attachments={data.threadAttachmentsURL[index]}
                          />
                        </div>
                      )}
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {data.threadAttachments &&
                        data.threadAttachments[index].map(
                          (attachment) => {
                            return (
                              <div className="mt-3 mb-3 ms-3">
                                <AttachmentBox attachment={attachment} />
                              </div>
                            );
                          }
                        )}
                    </div>
                  </div>
                </div>
              );
            }
          })}
        {!data.answer.includes("vizsep") && data.answer.length >= 550 && (
          <div className={`${isExpand ? "" : "fader"}`}></div>
        )}
        {!data.answer.includes("vizsep") && data.answer.length >= 550 && (
          <div className={`mb-2 mt-2 showmorediv`}>
            {isExpand ? (
              <span onClick={() => onChangeExpand(false)}>
                <i
                  className="fa fa-angle-up"
                  style={{ fontWeight: "bold", cursor: "pointer" }}
                ></i>
              </span>
            ) : (
              <span
                style={{ fontSize: "14px", cursor: "pointer" }}
                onClick={() => onChangeExpand(true)}
              >
                <i
                  className="fa fa-angle-down"
                  style={{ fontWeight: "bold" }}
                ></i>{" "}
                show more
              </span>
            )}
          </div>
        )}
        {/* {CURRENT_ROLE === 'Expert' &&
          (data.questionStatus === 'answered' || data.questionStatus === 'open') &&
          (
            <>
              <div className='col-lg-12 col-xs-12 col-sm-12 text-end'>
                <DeclineButton onClick={() => onClickModalDecline()}>Decline</DeclineButton>
                <AnswerNowButton onClick={() => onClickAnswerNow(data)}>Answer Now</AnswerNowButton>
              </div>
            </>
          )
        } */}
        {data.imageAttachments.length > 0 && (
          <div style={{ textAlign: "center" }}>
            <CarouselImage attachments={data.imageAttachments} />
          </div>
        )}
        {data.url && (
          <div>
            <span style={{ fontSize: "13px" }}>
              URL: <a href={data.url}>{data.url}</a>
            </span>
          </div>
        )}
        <div style={{ marginTop: "12px" }}>
          {data.attachments &&
            data.attachments.map((attachment, index) => {
              if (attachment.name.includes(".mp4")) {
                return (
                  <div style={{ textAlign: "center" }}>
                    <video
                      style={{ width: "70%" }}
                      id={data.answerUuid}
                      controls
                      onBlur={() => handlePauseAllVideo()}
                    >
                      <source src={attachment.objectUrl} />
                    </video>
                  </div>
                );
              }
            })}
          {/* {data.attachments && data.attachments.length > 0 } */}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "12px" }}>
          {data.attachments &&
            data.attachments.map((attachment, index) => {
              return (
                <AttachmentBox key={attachment.name} attachment={attachment} />
              );
            })}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent:
              data.popularityScore === undefined ? "end" : "space-between",
          }}
        >
          {data.popularityScore && (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={
                <Tooltip>Number of times this answer was viewed</Tooltip>
              }
            >
              <span className="popularityScore" style={{ cursor: "pointer" }}>
                <i
                  className="fa fa-eye"
                  style={{ paddingRight: "5px", color: "#7988a2" }}
                ></i>
                {data.popularityScore}
              </span>
            </OverlayTrigger>
          )}
          { CURRENT_ROLE === 'Seeker' &&  data.answerStatus !== "accepted" &&
            origData.postedUserUuid === userState.geoAttributes.userId &&
            ratings !== null &&
            ratings[
              data.originalAnswerUuid === undefined
                ? data.docId
                : data.originalAnswerUuid
            ] !== undefined &&
            ratings[
              data.originalAnswerUuid === undefined
                ? data.docId
                : data.originalAnswerUuid
            ].rating === null &&
            ratings[
              data.originalAnswerUuid === undefined
                ? data.docId
                : data.originalAnswerUuid
            ].feedback === null && (
              <>
                <span style={{ flex: "auto" }}>
                  <button
                    className="followUpButton btn"
                    onClick={() => onClickSendModalData()}
                    disabled={data.userInitiatedCuration ? true : false}
                  >
                    Request Follow-Up
                  </button>
                </span>
              </>
            )}
          <span style={{ paddingLeft: "12px" }}>
            {ratings !== null &&
              ratings[
                data.originalAnswerUuid === undefined
                  ? data.docId
                  : data.originalAnswerUuid
              ] !== undefined && (
                <Rating
                  id={
                    data.originalAnswerUuid === undefined
                      ? data.docId
                      : data.originalAnswerUuid
                  }
                  rating={
                    ratings[
                      data.originalAnswerUuid === undefined
                        ? data.docId
                        : data.originalAnswerUuid
                    ]
                  }
                  helpful={undefined}
                  isDisable={
                    data.expertFirstName === "Vizerto" ? true : undefined
                  }
                />
              )}
          </span>
        </div>

        <div
          className={`${
            data.attachments && data.attachments.length > 0 ? "row mb-3" : null
          }`}
        ></div>
        <div></div>
        {CURRENT_ROLE === 'Seeker' &&  ratings !== null &&
          ratings[
            data.originalAnswerUuid === undefined
              ? data.docId
              : data.originalAnswerUuid
          ] !== undefined &&
          ratings[
            data.originalAnswerUuid === undefined
              ? data.docId
              : data.originalAnswerUuid
          ].rating !== null &&
          ratings[
            data.originalAnswerUuid === undefined
              ? data.docId
              : data.originalAnswerUuid
          ].feedback === null && (
            <div
              className="row"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <FeedbackWindow
                answerUuid={
                  data.originalAnswerUuid === undefined
                    ? data.docId
                    : data.originalAnswerUuid
                }
                isSuccess={feedbackConfirmation}
                rating={
                  ratings[
                    data.originalAnswerUuid === undefined
                      ? data.docId
                      : data.originalAnswerUuid
                  ].rating
                }
                isDoc={data.docId !== undefined ? true : undefined}
              />
            </div>
          )}
        {ratings !== null &&
          ratings[
            data.originalAnswerUuid === undefined
              ? data.docId
              : data.originalAnswerUuid
          ] !== undefined &&
          ratings[
            data.originalAnswerUuid === undefined
              ? data.docId
              : data.originalAnswerUuid
          ].rating !== null &&
          ratings[
            data.originalAnswerUuid === undefined
              ? data.docId
              : data.originalAnswerUuid
          ].feedback !== null && (
            <div>
              <div className="form-control feedbackDiv">
                Feedback :{" "}
                <span
                  style={{
                    fontStyle: "italic",
                    fontSize: "12px",
                    color: "#666666",
                  }}
                >
                  "
                  {
                    ratings[
                      data.originalAnswerUuid === undefined
                        ? data.docId
                        : data.originalAnswerUuid
                    ].feedback
                  }
                  "
                </span>
              </div>
            </div>
          )}
      </div>
    );
  };

  const Rating = ({ rating, id, helpful, isDisable }) => {
    const ratingPercentage = (ratingClass) => {
      if (rating.percentage === null) {
        return `0%`;
      }
      if (ratingClass === "1") {
        return rating.percentage["1"] === undefined
          ? "0%"
          : `${rating.percentage["1"]}%`;
      }
      if (ratingClass === "4") {
        let star2 =
          rating.percentage["2"] === undefined ||
          rating.percentage["2"] === null
            ? 0
            : parseInt(rating.percentage["2"]);
        let star3 =
          rating.percentage["3"] === undefined ||
          rating.percentage["3"] === null
            ? 0
            : parseInt(rating.percentage["3"]);
        let star4 =
          rating.percentage["4"] === undefined ||
          rating.percentage["4"] === null
            ? 0
            : parseInt(rating.percentage["4"]);
        let allStar = star2 + star3 + star4;
        return `${allStar}%`;
      }
      if (ratingClass === "5") {
        return rating.percentage["5"] === undefined ||
          rating.percentage["5"] === null
          ? "0%"
          : `${rating.percentage["5"]}%`;
      }
    };
    const renderTooltip = (props) => (
      <Tooltip {...props} className={styles.tooltipratings}>
        <span className={styles.ratingInfoGlobal}>
          <p style={{ color: "black" }}>Seeker Rating</p>
          <div
            style={{ textAlign: "center", color: "#949494", fontSize: "12px" }}
          >
            &nbsp;
            <span>
              {rating.overallRating === null
                ? 0
                : rating.overallRating.toFixed(1)}
            </span>
            <span>/5</span>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              className="progress"
              style={{
                width: "90%",
                textAlign: "center",
                height: "10px",
                borderRadius: "2px",
              }}
            >
              <div
                className="progress-bar progress-bar-warning"
                role="progressbar"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{
                  width: ratingPercentage("1"),
                  backgroundColor: "#ed260c",
                }}
              ></div>
              <div
                className="progress-bar progress-bar-warning"
                role="progressbar"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{
                  width: ratingPercentage("4"),
                  backgroundColor: "#fead02",
                }}
              ></div>
              <div
                className="progress-bar progress-bar-warning"
                role="progressbar"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{
                  width: ratingPercentage("5"),
                  backgroundColor: "#61d937",
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              color: "#949494",
              fontSize: "12px",
              marginBottom: "5px",
              marginTop: "5px",
            }}
          >
            <span>
              {rating.globalRatings == null ? 0 : rating.globalRatings} global
              ratings
            </span>
          </div>
          <br />
        </span>
      </Tooltip>
    );
   
    const onRateActionToastMessage = (message) => {
      return(
        <span style={{fontSize:'12px'}}>{message}</span>
      )
    }

    const onClickThumbs = (ratingNumber) => {
      let payload = {
        rating: ratingNumber,
        answerUuid: isDisable === undefined ? id : null,
        docId: isDisable !== undefined ? id : null,
        feedback: rating.feedback,
      };
      rateRecommandedAnswer(payload).then((res1) => {
        if (res1 !== undefined && res1.data.success) {
          getAnswerRatingsInNotificationAction(
            ratingIds.toString(),
            docIds.toString()
          ).then((res) => {
            if (res !== undefined && res.data.success === true) {
              setRatings(res.data.data);
              toast.success(
                onRateActionToastMessage(res1.data.message),{
                  position:toast.POSITION.TOP_RIGHT
                }
              )
            }
          });
        }
      });
    };
    return (
      <OverlayTrigger placement="bottom" overlay={renderTooltip}>
        <div className={styles.ratingDiv}>
          {rating.rating !== null ? (
            <span
              className={styles.thumbsDown}
              onClick={() => onClickThumbs(1)}
              style={{
                color: rating.rating === 1 ? "red" : null,
              }}
            >
              <i className="fa fa-solid fa-thumbs-down fa-border-all"></i>
            </span>
          ) : (
            <span
              className={styles.thumbsDown}
              onClick={() => onClickThumbs(1)}
              style={{
                color: rating.overallRating === 1 ? "red" : null,
              }}
            >
              <i className="fa fa-solid fa-thumbs-down fa-border-all"></i>
            </span>
          )}
          {rating.rating !== null && (
            <span
              className={styles.thumbsUp}
              onClick={() => onClickThumbs(4)}
              style={{
                color:
                  rating.rating === 2 ||
                  rating.rating === 3 ||
                  rating.rating === 4
                    ? "#ffa500"
                    : null,
              }}
            >
              <i className="fa fa-solid fa-thumbs-up fa-border-all"></i>
            </span>
          )}
          {rating.rating === null && (
            <span
              className={styles.thumbsUp}
              onClick={() => onClickThumbs(4)}
              style={{
                color:
                  rating.overallRating === 2 ||
                  rating.overallRating === 3 ||
                  rating.overallRating === 4
                    ? "#ffa500"
                    : null,
              }}
            >
              <i className="fa fa-solid fa-thumbs-up fa-border-all"></i>
            </span>
          )}
          &nbsp;&nbsp;
          {rating.rating !== null ? (
            <span
              className={styles.thumbsDoubleUp}
              onClick={() => onClickThumbs(5)}
              style={{
                color: rating.rating === 5 ? "#A4BE7B" : null,
              }}
            >
              <i
                className="fa fa-solid fa-thumbs-up"
                style={{
                  transform: "rotate(16deg)",
                  marginRight: "-10px",
                  zIndex: 1000,
                  left: "9px",
                  marginLeft: "-7px",
                }}
              ></i>
              <i className="fa fa-solid fa-thumbs-up"></i>
            </span>
          ) : (
            <span
              className={styles.thumbsDoubleUp}
              onClick={() => onClickThumbs(5)}
              style={{
                color: rating.overallRating === 5 ? "#A4BE7B" : null,
              }}
            >
              <i
                className="fa fa-solid fa-thumbs-up"
                style={{
                  transform: "rotate(16deg)",
                  marginRight: "-10px",
                  zIndex: 1000,
                  left: "9px",
                  marginLeft: "-7px",
                }}
              ></i>
              <i className="fa fa-solid fa-thumbs-up"></i>
            </span>
          )}
        </div>
      </OverlayTrigger>
    );
  };
  const feedbackConfirmation = (data) => {
    getAnswerRatingsInNotificationAction(
      ratingIds.toString(),
      docIds.toString()
    ).then((res) => {
      if (res !== undefined && res.data.success === true) {
        setRatings(res.data.data);
      }
    });
  };
  const callRelatedQ = (data) => {
    let payload = {
      data: {
        id: data.questionUuid,
        text: data.questionText,
      },
    };
    recommendData(payload);
    navigate(`${Home_PAGE_URL}recommend`);
  };
  const onClickClarificationStatusChange = (flag) => {
    data.clarificationStatus = !flag;
  }
  const RerouteButton = styled(Button)({
    backgroundColor: 'var(--darker_color_shade)',
    borderColor: 'var(--darker_color_shade)',
    border: '1px solid var(--darker_color_shade)',
    color: '#fff',
    borderRadius: '3px',
    margin: '0px 3px',
    fontFamily: 'Poppins,Lato,sans-serif',
    fontSize: '14px',
    minWidth: '150px',
    textTransform: 'capitalize',
    fontWeight: 300,
    ':hover': {
        borderColor: 'var(--darker_color_shade)',
        border: '1px solid var(--darker_color_shade)',
        backgroundColor: '#fff',
        color: 'var(--darker_color_shade)',
    }
})
const UpdateAnswerButton = styled(Button)({
  backgroundColor: '#fd7400e8;',
  borderColor: '#fd7400e8;',
  border: '1px solid #fd7400e8;',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
      borderColor: '#fd7400e8;',
      border: '1px solid ##fd7400e8;',
      backgroundColor: '#fff',
      color: '#fd7400e8;',
  }
})
const VerifyNowButton = styled(Button)({
  backgroundColor: '#fd7400e8',
  borderColor: '#fd7400e8',
  border: '1px solid #fd7400e8',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
      borderColor: '#fd7400e8',
      border: '1px solid #fd7400e8',
      backgroundColor: '#fff',
      color: '#fd7400e8',
  }
})
const onClickModalReroute = (data)=>{
  const domainId =userState.expertTopics.filter((obj) => {
    if (obj.name === data.domain) {
        return obj;
    }
});
  getDomainOfQuestion(data.domain);
        getSelectedQuestionDataExpert(data.questionUuid);
        FetchForceReroute(data.questionUuid, domainId[0].indexId).then((res) => {
          if (res===undefined) return;
            if (res.data.success === true || res.data.data !== '') {
                advanceFilterModalToggle({ bool: true, value: "rerouteModal" })
                getForceRerouteUsersStatus(res.data.data);
            }
        })
}
  return (
    <>
      <div>
        <MiniDrawer>
          <div className="recommendPageHP">
            <div className="midBlock">
              <h3 className="backButton">
                <div style={{display:'flex'}} onClick={() => sendToHomePage()}>
                  <i
                    className="fa fa-arrow-left"
                    aria-hidden="true"
                    style={{
                      padding: "3px",
                      fontSize: "20px",
                      paddingRight: "7px",
                    }}
                  ></i>
                  <span>Back</span>
                </div>
              </h3>
            </div>
            {recommedState.isLoading ? (
              <SkeletonLoader />
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  className="questionBox"
                  style={{
                    width: recommendations.length > 0 ? "75%" : "100%",
                  }}
                >
                  {/* <div style={`clarify ? null :{ display: "flex", justifyContent: "space-between", paddingTop: "3px" }`}> */}
                  <div style={conditionalStyles.div}>
                    {clarify && CURRENT_ROLE === 'Seeker' ? (
                      renderClarifyCard()
                    ) : (
                      <h3 className="questionText">{isShowAnswerButton && data.userInitiatedCuration && <span className="requestedUpdate" title="Requested an update for the answer">Requested Update</span>}{data.questionStatus === 'answered' && isShowAnswerButton && <FontDownloadIcon sx={{marginRight:"3px"}} style={{
                        color: "#BEDB39",
                        fontSize: "22px"
                      }} />}{isShowAnswerButton && data.express && <img width="20" src={require('../../Images/fire.png')}/>}{data.question}</h3>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        justifyContent: "end",
                      }}
                    >
                      {data.clarificationStatus === true &&
                        data.answers &&
                        data.answers.length === 0 &&
                        clarify !== true && CURRENT_ROLE === 'Seeker' && (
                          <span
                            className="clarifyPopUp"
                            onClick={() => setClarify(!clarify)}
                            style={{ width: "max-content" }}
                          >
                            Expert requested for clarification
                          </span>
                        )}
                      {data.answers &&
                        data.answers.length === 0 &&
                        clarify !== true && CURRENT_ROLE === 'Seeker' && (
                          <i
                            className="fa fa-pencil-square-o"
                            style={{
                              cursor: "pointer",
                              color:
                                data.clarificationStatus === true
                                  ? "#fd7400"
                                  : "",
                              margin:
                                data.clarificationStatus === true
                                  ? "5px"
                                  : "5px",
                            }}
                            onClick={() => setClarify(!clarify)}
                          ></i>
                        )}
                        {
                          data.questionStatus !== 'answered' && !data.curationStatus && isShowAnswerButton &&
                          clarify !== true && CURRENT_ROLE === 'Expert' &&
                          (
                              <i className="fa fa-question-circle" style={{cursor:"pointer",margin:"5px",color:data.clarificationStatus === true ? "#fd7400" :"lightgray" }} onClick={()=>setClarify(!clarify)}>
                              </i>
                          )
                        }
                      {clarify ? null : (
                        <i
                          className={`fa fa-heart ${
                            data.favourite ? "animate-like" : "dropdownFavorite"
                          }`}
                          style={{ padding: "0px 0px" }}
                          onClick={() => onClickMarkFavorite()}
                        ></i>
                      )}
                    </div>
                  </div>
                  {clarify === false && data.seekerAttachments && data.seekerAttachments.length > 0 && data.seekerAttachments.map((obj,ind)=>{
                    return (
                      <AttachmentBox attachment={
                        obj
                      } key={ind}/>
                    )
                  })}
                  {clarify
                    ? null
                    : data.additionalContext && (
                        <div className="additionalText">
                          {data.additionalContext}
                        </div>
                      )}
                  {clarify ? null : (
                    <div style={{ display: "flex" }}>
                      <div className="domainDisplay">
                        <span className="domainText">Domain:</span>
                        <span className="domainName">{data.domain}</span>
                      </div>
                      {clarify ? null : (
                        <div className="tagDisplay">
                          <span className="domainText">Asked:</span>
                          <span className="dateText">
                            {moment(data.postedTimestamp).format(
                              "MMM DD, YYYY"
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  {clarify ? null : (
                    <div className="timestampDisplay">
                      {data.tags && data.tags.length > 0 ? (
                        <span className="domainText">Tags:</span>
                      ) : null}
                      {data.tags && data.tags.length > 0
                        ? data.tags.map((ta, index) => {
                            return (
                              <span
                                key={index}
                                className={
                                  ta.clickable
                                    ? "tagNames"
                                    : "tagNamesNonClickable"
                                }
                                onClick={() => selectTag(ta)}
                              >
                                {ta.term}
                              </span>
                            );
                          })
                        : null}
                    </div>
                  )}
                    {
                      CURRENT_ROLE === 'Expert' && clarify === true &&
                      renderClatifyCardForExpertRole()
                    }
                  {data.answers &&
                    data.answers.map((data, index) => {
                      return <AnswerText key={index} data={data} />;
                    })}
                    {CURRENT_ROLE === 'Expert' && isShowAnswerButton &&
          (data.questionStatus === 'answered' || data.questionStatus === 'open') && !clarify && 
          (
            <>
              <div className='col-lg-12 col-xs-12 col-sm-12 text-end'>
                {userState.reroute && <RerouteButton onClick={() => onClickModalReroute(data)}><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</RerouteButton>}
                <DeclineButton onClick={() => onClickModalDecline()}><i className="fa fa-times" style={{ paddingRight: '5px' }}></i>Decline</DeclineButton>
                {data.docId !== undefined ? 
                <VerifyNowButton onClick={() => onClickAnswerNow(data)} >Verify Now</VerifyNowButton>:data.userInitiatedCuration?
                <UpdateAnswerButton onClick={() => onClickAnswerNow(data)} >Update Answer</UpdateAnswerButton>
:               <AnswerNowButton onClick={() => onClickAnswerNow(data)} ><i className="fa fa-comment-o" style={{paddingRight:'5px'}}></i>Answer Now</AnswerNowButton>
}
              </div>
            </>
          )
        }
                </div>
                {recommendations.length > 0 && (
                  <div
                    className="questionBoxRelated"
                    style={{
                      marginLeft: ".5rem",
                      width: "24%",
                      maxWidth: "24%",
                      height: "fit-content",
                    }}
                  >
                    <p className="relatedTitle">Related Questions</p>
                    <hr style={{ margin: "0px", marginBottom: "10px" }} />
                    <ul className="relatedText" style={{ marginLeft: "-15px" }}>
                      {recommendations.map((txt) => {
                        return (
                          <li
                            style={{ lineHeight: "100%", marginBottom: "10px" }}
                          >
                            <span
                              className="relatedSubText"
                              onClick={() => callRelatedQ(txt)}
                            >
                              {txt.questionText}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        </MiniDrawer>
      </div>
    </>
  );
}
